import axios from 'axios';
import { store } from '../store/store';
import { Logout } from '../store/actions/AuthActions';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.request.use((config) => {
    const state = store.getState();
    const token = state.auth.auth.token;
    config.params = config.params || {};
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Response interceptor to handle 401 unauthorized responses
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle 401 Unauthorized responses
        if (error.response && [401, 403].includes(error.response.status)) {
            try {
                // Get the current state to check if user is logged in
                const state = store.getState();
                const isLoggedIn = state.auth.auth.token;
                
                // Only logout if user is currently logged in
                if (isLoggedIn) {
                    const navigate = (path) => {
                        window.location.href = path;
                    };
                    
                    // Dispatch logout action
                    store.dispatch(Logout(navigate));
                }
            } catch (interceptorError) {
                window.location.href = '/login';
            }
        }
        
        // Always reject the promise so the calling code can handle the error
        return Promise.reject(error);
    }
);

export default axiosInstance;
